// components/common/SectionCard.jsx
import React from 'react';
import { CheckIcon,EditIcon,SaveIcon } from './Icons';

const SectionCard = ({ 
  title, 
  children, 
  isComplete, 
  onSave, 
  canSave, 
  hasChanges, 
  isActive, 
  onActivate,
  isRtl
}) => {
  return (
    <div 
      className={`mb-6 rounded-xl overflow-hidden transition-all duration-300 ${
        isActive 
          ? 'bg-white dark:bg-gray-800 shadow-lg border-2 border-cyan-500 dark:border-cyan-600' 
          : isComplete 
            ? 'bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 opacity-90' 
            : 'bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 opacity-80'
      }`}
    >
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center space-x-2">
          <div className={`flex items-center justify-center w-6 h-6 rounded-full ${
            isComplete ? 'bg-emerald-500 text-white' : 'bg-gray-200 dark:bg-gray-700'
          }`}>
            {isComplete ? <CheckIcon /> : null}
          </div>
          <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">{title}</h2>
        </div>
        <div className="flex items-center space-x-2">
          {isComplete && !isActive && (
            <button
              onClick={onActivate}
              className="flex items-center px-3 py-1 text-sm rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-all"
            >
              <EditIcon />
              <span className="ml-1">Edit</span>
            </button>
          )}
          {isActive && (
            <button
              onClick={onSave}
              disabled={!canSave}
              className={`flex items-center px-3 py-1 text-sm rounded-md transition-all ${
                canSave 
                ? hasChanges 
                  ? 'bg-gradient-to-r from-cyan-500 to-emerald-500 text-white hover:from-cyan-600 hover:to-emerald-600 shadow-sm' 
                  : 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300'
                : 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-gray-700 dark:text-gray-500'
              }`}
            >
              <SaveIcon />
              <span className="ml-1">{hasChanges ? "Save" : "Saved"}</span>
            </button>
          )}
        </div>
      </div>
      <div className={`p-6 ${isActive ? 'bg-white dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-900'}`} dir={isRtl ? "rtl" : "ltr"}>
        {children}
      </div>
    </div>
  );
};

export default SectionCard;